<template>
  <base-section
    id="tss-2022"
    space="0"
  >
    <v-card
      class="mx-auto"
      max-width="100%"
    >
      <v-img
        :src="require(`@/images/tss22.png`)"
      />

      <v-card-title>
        TSS 2022 @ Barcelona
      </v-card-title>

      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="show1 = !show1"
        >
          Read More
        </v-btn>

        <v-spacer />

        <v-btn
          icon
          @click="show1 = !show1"
        >
          <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show1">
          <v-divider />

          <v-card-text>
            Test Spring School edition of 2022 was successfull!
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </base-section>
</template>
<script>
  export default {
    name: 'Tss2022',
    data: () => ({
      show1: false,
    }),
  }
</script>
